import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Icon from "@amzn/meridian/icon";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import { Card } from "@amzn/meridian";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "src/store/store";
import { createWorkflowInspection } from "src/store/workflowSlice";



const WorkflowCard = ({
  workflow,
}: any) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  
  const handleClick = async () => {
    // Create new workflow inspection and set inspectionId in workflow state
    await dispatch(createWorkflowInspection());
    
    navigate("/configurationDrivenInspections/execute");
  };
  
  return (
    <Card
      spacingInset="200 400"
      onClick={handleClick}
    >
      <Row alignmentHorizontal="justify" height={64}>
        <Column spacing="200">
          <Row>
            <Text type="b300">{workflow.name}</Text>
          </Row>
        </Column>
        <Icon tokens={chevronRightSmallTokens} />
      </Row>
    </Card>
  );
};

export default WorkflowCard;
